import { Component, EventEmitter, Output, input, ChangeDetectionStrategy } from '@angular/core';
import { Employee } from '@coin/shared/core/util-models';
import { OrganisationService } from '../../models/organisation-service.model';
import { MatIcon } from '@angular/material/icon';
import { SimplebarAngularModule } from 'simplebar-angular';
import { OrgTreeOverviewItemComponent } from './org-tree-overview-item/org-tree-overview-item.component';
import { OrgTreeOverviewItemsComponent } from './org-tree-overview-items/org-tree-overview-items.component';
import { V2CardComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'customer-org-tree-overview',
  templateUrl: './org-tree-overview.component.html',
  styleUrls: ['./org-tree-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2CardComponent,
    MatIcon,
    SimplebarAngularModule,
    OrgTreeOverviewItemComponent,
    OrgTreeOverviewItemsComponent
  ]
})
export class OrgTreeOverviewComponent {
  readonly rootEmployee = input<Employee>(undefined);
  readonly selectedEmployeeId = input<string>(undefined);
  readonly service = input<OrganisationService>(undefined);
  readonly seasonId = input<string>(undefined);
  readonly openEmployeeInView = input<(payload: { node: Employee; fullTree: boolean }) => unknown>(undefined);
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  public onClose(): void {
    this.close.emit();
  }
}
